module.exports = __webpack_public_path__ + "static/media/item_13_2_comp.d57680dc.png";